import React from "react";
import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import CommentReusirVotreVenteCards from "SanityComponents/CommentReusirVotreVenteCards";
import OffreProComponent from "../../sanity/Components/OffreProComponent/OffreProComponent";
import Footer from "../../SanityComponents/Footer/Footer";
import style from "../style.module.css";
import AnnoncesLpHeader from "SanityComponents/AnnoncesLpHeader";
import AnnoncesLpHeaderImage from "SanityComponents/AnnoncesLpHeaderImage";

import GroupFormLp from "SanityComponents/GroupFormLp";
import LinksComponent from "SanityComponents/LocationAnnoncesLp/LinksComponent";
import AnnoncesLpCardsComponent from "SanityComponents/LocationAnnoncesLp/AnnoncesLpCardsComponent";
import AnnoncesLpPostsComponent from "SanityComponents/LocationAnnoncesLp/AnnoncesLpPostsComponent";
import UrlTrack from "SanityComponents/LocationAnnoncesLp/UrlTrack";
import page_grid from "styles/global/page_grid.module.css";
import SanityHeadSeo from "../../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import LpFormSection from "../../SanityComponents/LpFormSection";
import AffinezRecherche from "SanityComponents/LocationAnnoncesLp/AffinezRecherche";
import TitleButtonComponent from "../../SanityComponents/TitleButtonComponent";

import { slug_to_province } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import ArticleInsideListingList from "components/v2/Listings/ArticleInsideListingList";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function LocationAnnoncesLp(props: {
  slug: string;
  data: any | null;
  listings?: any | null;
  articleData?: any | null;
}) {
  const { t, lang } = useTranslation("newLp");
  const { data } = props;

  let province = slug_to_province[props.slug];

  return (
    <div style={{ top: "60px", position: "relative" }}>
      {data?.content?.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <>
              <AnnoncesLpHeaderImage
                backgroundUrl={
                  item.background_image
                    ? urlFor(item.background_image)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                t={t}
                lang={lang}
                isHeaderBlocks={item.isHeaderBlock}
                groupFormHeader={item.groupFormHeader}
              />
            </>
          );
        }
      })}
      <div className={page_grid.page__container}>
        {data?.content.map((item, key) => {
          if (item._type == "lpheader") {
            return (
              <>
                <AnnoncesLpHeader
                  index={key}
                  title={item.titre ? item.titre[lang] : ""}
                  subtitle={item.soustitre ? item.soustitre[lang] : null}
                  secondeSubtitle={
                    item.secondsoustitre ? item.secondsoustitre[lang] : null
                  }
                  overlay={item.overlay_image}
                  content={item.content}
                  backgroundUrl={
                    item.background_image
                      ? urlFor(item.background_image)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()
                      : null
                  }
                  cardHeader={item.cardHeader ? item.cardHeader : []}
                  groupFormHeader={item.groupFormHeader}
                  component={
                    <>
                      {item.groupFormHeader ? (
                        <GroupFormLp
                          title={"Louer le bien qui me ressemble"}
                          subTitle={
                            "Agenz c’est plus de 80 000 annonces d’appartements, de maisons ou de terrains à votre disposition pour répondre à votre projet de location immobilière. "
                          }
                          SearchBarLpAnnonces={
                            item.SearchBarLpAnnonces
                              ? item.SearchBarLpAnnonces
                              : null
                          }
                          slug={props.slug}
                        />
                      ) : null}
                    </>
                  }
                  isHeaderBlocks={item.isHeaderBlock}
                  t={t}
                  lang={lang}
                />
              </>
            );
          } else {
            return (
              <>
                {item._type == "AnnoncesLpListingsTitle" &&
                item.type_bien &&
                props.listings[item.type_bien].length > 0 ? (
                  <>
                    <div className={style.cardsContainer}>
                      <AnnoncesLpCardsComponent
                        listings={props.listings[item.type_bien]}
                        transaction_type={props.listings["transaction_type"]}
                        title={item.title[lang]}
                        btnText={
                          item.button_text
                            ? item.button_text[lang]
                              ? item.button_text[lang]
                              : ""
                            : ""
                        }
                        btnLink={item.button_link ? item.button_link : ""}
                      />
                    </div>
                  </>
                ) : null}
                {item._type == "LpFormSection" ? (
                  <div className={style.lpFormSection}>
                    <LpFormSection
                      title={item.title[lang]}
                      lang={lang}
                      province={province}
                      transaction_type={
                        props.slug == "louer" ? "Location" : "Vente"
                      }
                      t={t}
                    />
                  </div>
                ) : null}
                {item._type == "AffinezRecherche" ? (
                  <div className={style.affinezRecherche}>
                    <AffinezRecherche title={item.title[lang]} />
                  </div>
                ) : null}
                {item?.TitleButtonImmoVilleArray?.length > 0 ? (
                  <div className={style.containerBtnTitle}>
                    <TitleButtonComponent
                      data={item.TitleButtonImmoVilleArray}
                      lang={lang}
                    />
                  </div>
                ) : null}
              </>
            );
          }
        })}
        {props.articleData && (
          <ArticleInsideListingList articleData={props.articleData} />
        )}

        {data?.content.map((item, key) => {
          return (
            <>
              {item?.AnnoncesLpLinksArray?.length > 0 ? (
                <>
                  <div className={style.linksContainer}>
                    <LinksComponent
                      data={item.AnnoncesLpLinksArray}
                      lang={lang}
                    />
                  </div>
                </>
              ) : null}
              {item?.annoncesLpLinksObject ? (
                item?.annoncesLpLinksObject?.AnnoncesLpLinksArray?.length >
                0 ? (
                  <>
                    <div className={style.linksContainer}>
                      <LinksComponent
                        data={item.annoncesLpLinksObject.AnnoncesLpLinksArray}
                        lang={lang}
                        isFlex={item.annoncesLpLinksObject.isFlex}
                      />
                    </div>
                  </>
                ) : null
              ) : null}
              {item.GuidLocationCards ? (
                <>
                  <div className={style.articlesContainer}>
                    <AnnoncesLpPostsComponent
                      data={item.GuidLocationCards.GuidLocationCardsArray}
                      title={
                        item.GuidLocationCards.titre
                          ? item.GuidLocationCards.titre[lang]
                          : null
                      }
                      lang={lang}
                      articlesType="location"
                    />
                  </div>
                </>
              ) : null}
              {item.GuidAcheteurCards &&
              item.GuidAcheteurCards.GuidAcheteurCardsArray?.length > 0 ? (
                <>
                  <div className={style.articlesContainer}>
                    <AnnoncesLpPostsComponent
                      data={item.GuidAcheteurCards.GuidAcheteurCardsArray}
                      title={
                        item.GuidAcheteurCards.titre
                          ? item.GuidAcheteurCards.titre[lang]
                          : ""
                      }
                      lang={lang}
                      articlesType="achat"
                    />
                  </div>
                </>
              ) : null}
              {item._type == "SanityFooter" ? (
                <>
                  <div className={style.urlTrack}>
                    <UrlTrack slug={props.slug} />
                  </div>
                  <div className={`${style.footer} ${style.footerAnnonces}`}>
                    <div className={style.footerDeskd}>
                      <Footer
                        propos={item.propos[lang]}
                        proposText={item.text ? item.text[lang] : ""}
                        donnee={item.donnees[lang]}
                        donneeText={item.textdonnee[lang]}
                        technologie={item.technologie[lang]}
                        technologieText={item.texttechnologies[lang]}
                        logo={urlFor(item.agenz_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        facebook={urlFor(item.facebook_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        instagram_logo={urlFor(item.instagram_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        linked_in={urlFor(item.linkedin_logo)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        socialMediaText={item.socialMediatext}
                        copyRightText={item.permission_text}
                      />
                    </div>
                  </div>
                </>
              ) : null}
              {item._type == "WhatssapComponent" ? (
                <WhatssapComponent
                  number={item?.numberPhone ? item.numberPhone : null}
                  message={item?.message ? item.message[lang] : null}
                />
              ) : null}
              {item._type == "SanityHeadSeo" ? (
                <SanityHeadSeo
                  key={key}
                  title={item.titre ? item.titre[lang] : ""}
                  ogTitle={item.titre ? item.titre[lang] : ""}
                  description={item.description ? item.description[lang] : ""}
                  ogDescription={item.description ? item.description[lang] : ""}
                  canonicalUrl={item.canonicalUrl}
                  ogTwitterImage={
                    item.mainImage
                      ? urlFor(item.mainImage)
                          .width(250)
                          .height(250)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()
                      : null
                  }
                  ogType={item.ogType}
                  ogImageUrl={
                    item.mainImage
                      ? urlFor(item.mainImage)
                          .width(250)
                          .height(250)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()
                      : null
                  }
                  structuredData={null}
                >
                  <></>
                </SanityHeadSeo>
              ) : null}
              {item.CommentResussirComponent?.length > 0 &&
                item.CommentResussirComponent.map((element, ind) => {
                  return (
                    <>
                      <CommentReusirVotreVenteCards
                        title={element.titre && element.titre[lang]}
                        button_text={
                          element.button_text && element.button_text[lang]
                        }
                        body={
                          lang == "ar"
                            ? element?.body_text?.body_ar
                              ? element?.body_text?.body_ar
                              : null
                            : element?.body_text?.body_fr
                            ? element?.body_text?.body_fr
                            : null
                        }
                        button_link={element.button_link}
                        mainImage={
                          element.mainImage
                            ? urlFor(element.mainImage)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        orientation={element.orientation_lr}
                        lang={lang}
                      />
                    </>
                  );
                })}
              {item.OffreProComponent?.length > 0 &&
                item.OffreProComponent.map((element, ind) => {
                  return (
                    <OffreProComponent
                      title={element.titre ? element.titre[lang] : ""}
                      texte={element.text[lang]}
                      text2={element.text2 ? element.text2[lang] : ""}
                      overlay={element.overlay_image}
                      button_text={element.button_text[lang]}
                      backgroundColor={element.background_color}
                      orientation_lr={element.orientation_lr}
                      button_link={element.button_link}
                      mainImage={
                        element.mainImage
                          ? urlFor(element.mainImage)
                              .width(600)
                              .height(600)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      lang={lang}
                    />
                  );
                })}
            </>
          );
        })}
      </div>
    </div>
  );
}
